module.exports = __webpack_public_path__ + "img/table-addcb-icon-white.40ed5df0.svg";